import { BaseApi } from './base.api'
import { METHOD_AXIOS } from '../utils/constant'

/**
 * Editor API for platform folder categories (course chips).
 * GET returns tree: roots with subCategories (isNew + intro fields).
 * PUT /:id/is-new toggles the New badge flag.
 * PUT /:id/intro updates Book/Course introduction CMS fields.
 */
export class CourseCategoryAdminApi extends BaseApi {
	constructor() {
		super('api/editor/platform-folder-category')
	}

	/** @returns {Promise<Array>} category tree */
	async getAll() {
		return this.get('')
	}

	/**
	 * @param {number} id
	 * @param {boolean} isNew
	 */
	async setIsNew(id, isNew) {
		return this.requestJson(`${id}/is-new`, { isNew }, METHOD_AXIOS.PUT)
	}

	/**
	 * @param {number} id
	 * @param {object} payload
	 */
	async setIntro(id, payload) {
		return this.requestJson(`${id}/intro`, payload, METHOD_AXIOS.PUT)
	}
}
